module.exports = __webpack_public_path__ + "static/media/t_apple.b2c765cd.png";